<div>
    <app-nav class="_sticky _top-0 _z-50 _block _border-b _shadow-bottom"></app-nav>
    <div class="_flex _flex-row _items-start _justify-center sm-max:_w-full _mx-auto">
        <div class="md:_container _mx-auto _w-full _py-2 _px-4 md:_px-2">
            <div class="_flex _flex-col">
                <div class="_flex _flex-col xs:_flex-row _justify-between _w-full _my-4 sm:_my-8">
                    <h1 class="_text-h4-m md:_text-h2 sm-max:_mb-4">Your {{ "wishlist" | businessName }}s</h1>    
                    <button class="_button-secondary" (click)="createWishlist($event)">
                        <i class="fa-light fa-plus _mr-1"></i> 
                        New {{ "wishlist" | businessName }}
                    </button>
                </div>
            
                <div *ngIf="loading" class="_flex _justify-center _items-center _py-8">
                    <app-loading-spinner></app-loading-spinner>
                </div>

                <app-empty-state-screen 
                    *ngIf="!loading && isEmpty"
                    intoBoxMessage="No {{ 'wishlist' | businessName }}s found" >
                    <div [matTooltip]="'Create your first proposal'" class="_mt-4">
                        <button (click)="createWishlist($event)" class="_button-primary">
                            Create first {{ "wishlist" | businessName }}
                        </button>
                    </div>
                </app-empty-state-screen>

                <ng-container *ngIf="!loading && !isEmpty">
                    <app-overflow-container 
                        [useArrows]="[false, false]"
                        [useGradients]="[false, true]">
                        <div class="_w-full">
                            <table mat-table matSort sortingCache [dataSource]="dataSource" *ngIf="dataSource" class="_min-w-max _w-full">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef> 
                                        <div class="_py-2 _pr-4">Description</div>
                                    </th>
                                    <td mat-cell *matCellDef="let wishlist"> 
                                        <span class="_font-bold _py-2 _pr-4">{{ wishlist.name }}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="status">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef> 
                                        <div class="_py-2 _px-4">Status</div>
                                    </th>
                                    <td mat-cell *matCellDef="let wishlist"> 
                                        <div class="_py-2 _px-4">{{ wishlist.status }}</div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="wishes">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef> 
                                        <div class="_py-2 _px-4">Listings</div>
                                    </th>
                                    <td mat-cell *matCellDef="let wishlist"> 
                                        <div class="_py-2 _px-4">{{ wishlist.wishes?.length || '0' }}</div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="right-aligned-sorted-header"> 
                                        <div class="_py-2 _px-4">Actions</div>
                                    </th>
                                    <td mat-cell *matCellDef="let wishlist" >
                                        <div class="_flex xs-max:_gap-1 xs-max:_py-2 xs-max:_items-end _justify-end">
                                            <a (click)="editWishlist(wishlist)" class="_link _gap-1">
                                                <i class="fa-light fa-pen-to-square"></i>
                                                Edit
                                            </a>
                                            <span class="_mx-2">|</span>
                                            <a target="_blank" (click)="navigateTo($event, wishlist)" class="_link _gap-1">
                                                <i class="fa-sharp fa-light fa-eye"></i>
                                                Preview
                                            </a> 
                                            <span class="_mx-2">|</span>
                                            <a target="_blank" (click)="copyLink($event, wishlist)" class="_link _gap-1">
                                                <i class="fa-light fa-copy"></i>
                                                Copy share link
                                            </a>
                                            <span class="_mx-2">|</span>
                                            <a (click)="emailLink($event, wishlist)" title="Share by Email" class="_link _gap-1">
                                                <i class="fa-light fa-envelope"></i>
                                                Email share link
                                            </a>
                                            <span class="_mx-2">|</span>
                                            <a (click)="archiveWishlist($event, wishlist)" class="_link _gap-1">
                                                <i class="fa-light fa-trash"></i>
                                                Remove
                                            </a>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                                <tr mat-row
                                    *matRowDef="let wishlist; columns: columnsToDisplay; "></tr>
                            </table>
                        </div>
                    </app-overflow-container>

                    <mat-paginator 
                        class="_mt-4"
                        [pageSize]="100" 
                        [pageSizeOptions]="[10, 25, 50, 100, 500]"
                        aria-label="Select page">
                    </mat-paginator>
                </ng-container>
            </div>
        </div>
    </div>
</div>
